export default "__VITE_ASSET__DViQ4Cj6__"